module.exports = __webpack_public_path__ + "img/home.0b66f9e8.svg";